function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

function initRegister() {
  const registerForm = document.querySelector('#CustomerRegisterForm');
  const fields = registerForm.querySelectorAll('.cf-field');
  const buttons = registerForm.querySelectorAll('.cf-button');

  [].forEach.call(buttons, (button) => {
    button.classList.add('button--large');
  });

  [].forEach.call(fields, (field) => {
    const label = field.querySelector('label');
    const input = field.querySelector('input');

    // console.log(label);
    // console.log(input);

    label.classList.add('empty-field');

    if (input.value) {
      label.classList.remove('empty-field');
    }

    input.onfocus = function () {
      label.classList.remove('empty-field');
    };

    input.onblur = function () {
      if (input.value) {
        label.classList.remove('empty-field');
      } else {
        label.classList.add('empty-field');
      }
    };
  });
}

function formScripts() {
  const cfFormFieldsWrapper = document.querySelector('.cf-fields-container');

  const cfFormFields = cfFormFieldsWrapper.querySelectorAll('input');
  console.log(cfFormFields);

  const cfFormActions = document.querySelector('.cf-form-actions');
  console.log(cfFormActions);

  const cfFormActionsBtn = document.querySelector('.cf-submit-form');
  console.log(cfFormActionsBtn);

  // loop through all fields and add event listeners
  [].forEach.call(cfFormFields, (field) => {
    field.addEventListener('focusin', observeFormChange);
    field.addEventListener('focusout', observeFormChange);
    field.addEventListener('change', observeFormChange);
  });

  // Disable the submit button until the form is valid
  if (cfFormActionsBtn) {
    cfFormActionsBtn.disabled = true;
  }
  // cfFormFields.addEventListener('input', observeFormChange);

  function observeFormChange() {
    console.log('Form change detected');

    // First Name Validation
    let fNameError = true;
    const fname = document.body.querySelector(
      'input[data-cf-column-key="first_name"]',
    );
    if (fname.value.length !== 0) {
      fNameError = false;
    } else {
      fNameError = true;
    }

    console.log(fNameError);

    // Last Name Validation
    let lNameError = true;
    const lname = document.body.querySelector(
      'input[data-cf-column-key="last_name"]',
    );
    if (lname.value.length !== 0) {
      lNameError = false;
    } else {
      lNameError = true;
    }

    console.log(lNameError);

    // Email Validation
    let emailError = true;
    const email = document.body.querySelector(
      'input[data-cf-column-key="email"]',
    );
    const emailConf = document.body.querySelector(
      'input[aria-labelledby="576769label"]',
    );

    if (email.value.length !== 0 && emailConf.value.length !== 0) {
      if (email.value === emailConf.value) {
        emailError = false;
      } else {
        emailError = true;
      }
    }

    console.log(emailError);

    // Password Validation
    let passwordError = true;
    const password = document.body.querySelector(
      'input[data-cf-column-key="password"]',
    );
    const passwordConf = document.body.querySelector(
      'input[data-cf-column-key="password_confirmation"]',
    );

    if (password.value.length !== 0 && passwordConf.value.length !== 0) {
      if (password.value === passwordConf.value) {
        passwordError = false;
      } else {
        passwordError = true;
      }
    }

    console.log(passwordError);

    // Confirmation TickBox Validation
    let confirmationError = true;

    const confirmationContainer =
      document.body.querySelector('.registerConfirm');
    const confirmation = document.body.querySelector(
      'input[data-cf-column-key="confirmation"]',
    );

    // First, disabled the confirmation checkbox
    confirmation.disabled = true;

    // Only show confirm checkbox if the rest of the form is valid
    if (
      fNameError === false &&
      lNameError === false &&
      emailError === false &&
      passwordError === false
    ) {
      confirmationContainer.classList.add('show');
      confirmation.disabled = false;
    } else {
      confirmationContainer.classList.remove('show');
      confirmation.disabled = true;
    }

    // If the confirmation checkbox is ticked, enable the submit button
    confirmation.addEventListener('click', () => {
      if (confirmation.checked) {
        confirmationError = false;
        cfFormActionsBtn.disabled = false;
      } else {
        confirmationError = true;
        cfFormActionsBtn.disabled = true;
      }
    });
  }
}

function passwordReveal() {
  // Target the password input fields, then create our 'eyes' divs, and insert after the input fields.
  const passwordField = document.querySelector(
    "[data-cf-column-key='password']",
  );
  const revealEyesContainerPassword = document.createElement('div');
  revealEyesContainerPassword.classList.add('reveal');
  revealEyesContainerPassword.id = 'reveal-password';
  passwordField.after(revealEyesContainerPassword);

  const passwordConfirmField = document.querySelector(
    "[data-cf-column-key='password_confirmation']",
  );
  const revealEyesContainerPasswordConfirm = document.createElement('div');
  revealEyesContainerPasswordConfirm.classList.add('reveal');
  revealEyesContainerPasswordConfirm.id = 'reveal-password-confirmation';
  passwordConfirmField.after(revealEyesContainerPasswordConfirm);

  // Target the dynamically created elements that will toggle the functionality.
  const revealPasswordElement = document.querySelector('#reveal-password');
  const revealPasswordConfirmationElement = document.querySelector(
    '#reveal-password-confirmation',
  );

  // Run functionality when eyes are toggled.
  revealPasswordElement.onclick = function () {
    if (passwordField.type === 'password') {
      revealPasswordElement.classList.add('active');
      passwordField.type = 'text';
    } else {
      revealPasswordElement.classList.remove('active');
      passwordField.type = 'password';
    }
  };
  revealPasswordConfirmationElement.onclick = function () {
    if (passwordConfirmField.type === 'password') {
      revealPasswordConfirmationElement.classList.add('active');
      passwordConfirmField.type = 'text';
    } else {
      revealPasswordConfirmationElement.classList.remove('active');
      passwordConfirmField.type = 'password';
    }
  };
}

function checkFormIsAlive() {
  setTimeout(initRegister, 500);
  setTimeout(formScripts, 600);
  setTimeout(passwordReveal, 700);
}

if (document.body.classList.contains('template-register')) {
  waitForElm('.cf-react-target').then((elm) => {
    checkFormIsAlive();
  });
}
